import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import {
  postMedicamentos,
  setActiveStep,
  setShowForm,
} from "../../../actions/recetasDigitales/RecetasDigitales";
import {
  STEPPER_RECETAS
} from "../../../utils/constants";
import { RecetasDigitalesCard } from "../UI/RecetasDigitalesCard";
import { RecetasDigitalesAddMedicamento } from "./RecetasDigitalesAddMedicamento";
import { RecetasDigitalesMedicamento } from "./RecetasDigitalesMedicamento";
import AlertaMedicamento from "../../empadronamiento/UI/AlertaMedicamento";
//import { Redirect } from "react-router-dom";

export const RecetasDigitalesMedicamentos = (props) => {
  const dispatch = useDispatch();

  const { medicamentos = [], recetaSeleccionada = {} } = useSelector(
    (state) => state.recetasDigitales
  );
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const avanzarPantalla = () => {
    dispatch(setActiveStep(STEPPER_RECETAS.CONFIRMACION));
  };

  const onConfirmHandler = () => {
    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idRecetaDigital: recetaSeleccionada.idRecetaDigital,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        idTipoReceta: recetaSeleccionada.idTipoReceta,
        medicamento: medicamento.medicamento
      };
    });

    dispatch(
      postMedicamentos({ medicamentos: medicamentosFormateados }, avanzarPantalla)
    );

  };

  const onClickSiguienteHandler = () => {
    var medicamentosValidos = true;
    var mensajeString = "";
    var drogas = "";
    setMensaje("");

    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idRecetaDigital: recetaSeleccionada.idRecetaDigital,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        idTipoReceta: recetaSeleccionada.idTipoReceta,
        medicamento: medicamento.medicamento
      };
    });

    //Primero busco medicamentos de mas
    medicamentosFormateados.forEach(medicamento => {
      const presentacion = medicamento.medicamento.presentacion.toLowerCase();

      if (!(presentacion.includes('ml') || presentacion.includes(' g') || presentacion.includes(' mg') || presentacion.includes(' kg') ||
        presentacion.includes(' l'))) {
        medicamentosValidos = false;

        if (medicamento?.medicamento?.drogas.length > 40) {
          drogas = medicamento?.medicamento?.drogas.substring(0, 40) + "[...]";
        } else {
          drogas = medicamento?.medicamento?.drogas;
        }

        if (mensajeString !== "") {
          mensajeString = `${mensajeString}\n El medicamento ${medicamento.medicamento?.nombre} | ${medicamento.medicamento?.laboratorio} | ${drogas} | ${medicamento?.medicamento?.presentacion}, carece de UNIDAD en la presentación.\n`;
        } else {
          mensajeString = "El medicamento " + medicamento.medicamento?.nombre + " | " + medicamento.medicamento?.laboratorio + " | " + drogas + " | " + medicamento?.medicamento?.presentacion + ", carece de UNIDAD en la presentación.\n";
        }
      }
    });


    //Validacion
    if (medicamentosValidos) {
      onConfirmHandler();
    } else {
      setMensaje(mensajeString + " ¿Desea continuar?");
      setOpen(true);
    }

  };


  return (
    <RecetasDigitalesCard width={"75%"}>
      <RecetasDigitalesAddMedicamento />
      {medicamentos.map((medicamento, index) => {
        return (
          <RecetasDigitalesMedicamento
            key={index}
            medicamento={medicamento}
            idTipoReceta={recetaSeleccionada.idTipoReceta}
          />
        );
      })}
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            dispatch(setActiveStep(STEPPER_RECETAS.DETALLE_RECETA));
            dispatch(setShowForm(false));
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSiguienteHandler}
        >
          Siguiente
        </Button>
      </div>
      {/*redirect && (
        <Redirect
          to={{
            pathname: "/autorizaciones",
          }}
        />
        )*/}
      {<AlertaMedicamento
        open={open}
        setOpen={setOpen}
        mensaje={mensaje}
        handleDecisionYes={onConfirmHandler}
        handleDecisionNo={false}
      />}
    </RecetasDigitalesCard>
  );
};
